export const isMonthDifferent = (d1: Date, d2: Date): boolean =>
  !(d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear());

export const getRangeOfData = (dates, yearsCount) => {
  const currentYear = new Date(dates[0]).getFullYear();
  const endOfRange = currentYear + yearsCount;
  let range = { firstIndex: 0, lastIndex: 0 };
  dates.map((v, i) => {
    if (v.includes(endOfRange) && !range.lastIndex) {
      range.lastIndex = i + 1;
    }
  });
  return range;
};

// get the maximum median value for the portfolio
export const getMaxMedianValue = (calculatedPerformance) =>
  calculatedPerformance[calculatedPerformance.length - 1].median;

export const generatePerformace = (data, amount, amountSP, yearsCount) => {
  let allUserPayment = 0;
  const calculatedPerformance: Array<{
    name: string;
    good: number;
    bad: number;
    median: number;
    veryBad: number;
    currentDate: Date;
  }> = [];

  let goodPreviousValue = 0;
  let badPreviousValue = 0;
  let medianPreviousValue = 0;
  let veryBadPreviousValue = 0;

  const range = getRangeOfData(data.dates, yearsCount);
  const dates: Array<Date> = data.dates.slice(0, range.lastIndex);
  const goodPerformance = data.good_projections.slice(0, range.lastIndex);
  const badPerformance = data.bad_projections.slice(0, range.lastIndex);
  const medianPerformance = data.median_projections.slice(0, range.lastIndex);
  const veryBadPerformance = data.extreme_bad_projections.slice(0, range.lastIndex);

  dates.forEach((date: Date, index) => {
    let goodCurrentValue = 0,
      badCurrentValue = 0,
      medianCurrentValue = 0,
      veryBadCurrentValue = 0,
      currentDate = new Date();

    // for the calculation of the first value, the formula is slightly different
    if (index === 0) {
      currentDate = date;
      allUserPayment += amount;
      goodCurrentValue = badCurrentValue = medianCurrentValue = veryBadCurrentValue = amount;
    } else {
      const performanceGoodWithoutSp =
        goodPreviousValue * (goodPerformance[index] / goodPerformance[index - 1]);
      const performanceBadWithoutSp =
        badPreviousValue * (badPerformance[index] / badPerformance[index - 1]);
      const performanceMedianWithoutSp =
        medianPreviousValue * (medianPerformance[index] / medianPerformance[index - 1]);
      const performanceVeryBadWithoutSp =
        veryBadPreviousValue * (veryBadPerformance[index] / veryBadPerformance[index - 1]);

      // if the month changed, we add a SP contribution
      const contribution =
        amountSP && isMonthDifferent(new Date(date), new Date(dates[index - 1])) ? amountSP : 0;
      allUserPayment += contribution;

      goodCurrentValue = performanceGoodWithoutSp + contribution;
      badCurrentValue = performanceBadWithoutSp + contribution;
      medianCurrentValue = performanceMedianWithoutSp + contribution;
      veryBadCurrentValue = performanceVeryBadWithoutSp + contribution;

      currentDate = date;
    }

    const fullYear = new Date(date).getFullYear();

    calculatedPerformance.push({
      name: fullYear.toString(),
      good: Math.round(goodCurrentValue * 100) / 100,
      bad: Math.round(badCurrentValue * 100) / 100,
      median: Math.round(medianCurrentValue * 100) / 100,
      veryBad: Math.round(veryBadCurrentValue * 100) / 100,
      currentDate: currentDate,
    });

    goodPreviousValue = goodCurrentValue;
    badPreviousValue = badCurrentValue;
    medianPreviousValue = medianCurrentValue;
    veryBadPreviousValue = veryBadCurrentValue;
  });

  const differenceYears = new Date().getFullYear() - new Date(dates[0])?.getFullYear();
  const maxMedianValue = getMaxMedianValue(calculatedPerformance);

  return {
    calculatedPerformance,
    differenceYears,
    allUserPayment,
    maxMedianValue,
  };
};

export const formatTickValue = (value, formatNumber) => {
  if (value >= 1000000) {
    return `${formatNumber(value / 1000000, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })} M`;
  }
  if (value >= 1000) {
    return `${formatNumber(value / 1000, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })} K`;
  }
  return value;
};
